import IntegrationCard from '../../components/integration-card/IntegrationCard';
import FYILogo from '../../assets/fyi.png';
import JobIntegration from './integrations/fyi/JobIntegration';
import { useState } from 'react';
import { ChevronLeftIcon } from '@heroicons/react/24/solid';
import { useWorkpaperContext } from '../../providers/WorkpaperProvider';
import { useIsFirmRole } from '../../hooks/use-is-firm-role';

function EditIntegrations(): JSX.Element {
    const { isExternalUser } = useIsFirmRole();
    const { readOnly, integrations } = useWorkpaperContext();

    const [focusedIntegration, setFocusedIntegration] = useState<string | undefined>();

    function handleIntegrationClick(id: string): void {
        if (readOnly) {
            return;
        }
        setFocusedIntegration(id);
    }

    return (
        <div>
            {focusedIntegration === undefined && (
                <div className="grid gap-y-8 w-fit">
                    <IntegrationCard
                        id="fyi"
                        title="FYI"
                        description="Pull your documents, clients and groups from FYI."
                        logo={FYILogo}
                        status={integrations?.fyi?.job ? 'CONNECTED' : 'DEFAULT'}
                        onConfigure={handleIntegrationClick}
                        isDisabled={isExternalUser}
                        beta
                    />
                </div>
            )}
            {focusedIntegration !== undefined && (
                <div>
                    <button
                        className="text-sm text-gray-600 flex items-center gap-1 mb-8"
                        onClick={(): void => setFocusedIntegration(undefined)}
                    >
                        <ChevronLeftIcon className="h-4 w-4" />
                        Integrations
                    </button>
                    {focusedIntegration === 'fyi' && <JobIntegration />}
                </div>
            )}
        </div>
    );
}

export default EditIntegrations;
